<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body pt-1">
                        <div class="table-top d-flex justify-content-start gap-2">

                            
                            <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="@/assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>


                                
                            </div>
                           
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        
                                        class="picker"
                                        @change="onDateChange"
                                        style="width: 268px !important;" 
                                    />
                                </div>
                            </div>
                                    
                            <div class="wordset">
                                <ul>
                                    <!-- <li class="" >
                                        <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                                type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                                    </li> -->
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                            @click="export_schedule"
                                            class="d-flex flex-column justify-content-between align-items-center btn btn-primary p-1 " style="margin-top: 10px !important;  margin-bottom: 0px !important;">
                                            <img src="../../../assets/img/Import_fill.png" alt="img" width="25" />

                                        </a>

                                    </li>

                                    
                                    

                                </ul>
                            </div>

                            
                            
                           
                        </div>
                       
                        <!-- /Filter -->
                        <div class="table-responsive mt-0">
                            <a-table :columns="columns" :data-source="filteredData" :pagination="pagination" :loading="loading">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                   

                                    <template v-if="column.key === 'task_amount'">
                                        <div class="productimgname">
                                            {{ rupiah(record.task_amount) }}
                                        </div>


                                    </template>

                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3" @click="show_izitoast">
                                            <img src="@/assets/img/icons/eye.svg" alt="img" />
                                        </a> -->
                                        <router-link class="me-3" to="editother_deduction" @click="edit(record);">
                                            <img src="@/assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage, rupiah } from "@/assets/js/function";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { watch } from "vue";

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'


export default {
    components: {
        DatePicker
        
    },
    data() {
        return {
            filter: false,
            title: "Other Deduction List",
            title1: "manage other deduction",
            items: [
                {
                    text: "Add Other Deduction ",
                    addname: "/addother_deduction",
                },
            ],

            // periode: new Date(),
            periode: [],

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Date",
                    dataIndex: "tanggal",
                    key: "tanggal",
                    sorter: {
                        compare: (a, b) => {
                            a = a.tanggal.toLowerCase();
                            b = b.tanggal.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
              
                {
                    title: "Employee",
                    dataIndex: "nama",
                    key: "nama",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "Amount",
                    dataIndex: "task_amount",
                    key: "task_amount",
                    sorter: {
                        compare: (a, b) => {
                            a = a.task_amount.toLowerCase();
                            b = b.task_amount.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Notes",
                    dataIndex: "task_name",
                    key: "task_name",
                    sorter: {
                        compare: (a, b) => {
                            a = a.task_name.toLowerCase();
                            b = b.task_name.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                },
            ],

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            loading: false,

            //filter
            query: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }

         const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')
        
        // Set default date range (1st to last day of current month)
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // zero-based
        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        this.periode = [
        this.formatDateLocal(start),
        this.formatDateLocal(end),
        ];

        this.index();
    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {

                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                item.tanggal.toLowerCase().includes(lowerCaseQuery) ||
                item.task_amount.toLowerCase().includes(lowerCaseQuery) ||
                item.fullname.toLowerCase().includes(lowerCaseQuery) ||
                item.task_name.toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {
        rupiah,
        // show_izitoast() {
        //     AlertBottom('tessst');
        // },
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },

        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },


        addNumberToObjects(objArray) {
            for (let i = 0; i < objArray.length; i++) {
                const newObj = { No: i + 1, ...objArray[i] };
                objArray[i] = newObj;
            }
            return objArray;
        },

        async export_schedule() {
            let formData = new FormData();
            appendForm(formData)

            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }
            
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true


            const api = base_url + '/v3/otherdeduction/export';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;

            if(data.status){
                const fileUrl = data.data.file_report;

                if (!this.periode) {
                    console.error("Error: this.periode is undefined or null");
                    return;
                }

                if (!fileUrl) {
                    // console.error("Error: file_report URL is missing!");
                    AlertPopup2("error", "", "Download link not found", true, 1500);
                    CloseLoading();
                    return;
                }

                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "Schedule.xlsx"); // You can change the filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },

        shortenDescription(description) {
            if (description.length > 35) {
                return description.substring(0, 35) + '...';
            } else {
                return description;
            }
        },

        onDateChange(value) {
            this.periode = value;
            this.index();
        },

        async index() {
            this.loading = true;
            
            let formData = new FormData();
            appendForm(formData)

            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;

           
            const api = base_url + '/v3/otherdeduction/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const otherDeduction = data.data.data_other_deduction;
            console.log('ini data overtime:', data)
            
            if(data.status){
                this.data = [];

                otherDeduction.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

               this.loading = false;
               
                localStorage.setItem('employeeList', JSON.stringify(data.data.data_employees));
                localStorage.setItem('lokasiList', JSON.stringify(data.data.data_lokasi));
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            

        },
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },

        async delete2() {
            
            let formData = new FormData();
            appendForm(formData)

            formData.append("id", this.id_terminate);

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;

            const api = base_url + '/v3/otherdeduction/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            
            if(data.status){
                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                this.data.splice(index, 1);
                AlertBottom(data.message);
                this.hideModal2('terminate');
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

         


        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
</style>